import { Currency, Locale } from '../apollo/graphqlSchema';
import { localeDictionary } from './utils';

const getCurrencySymbol = (currency: Currency, locale: Locale): string => {
  const formatter = new Intl.NumberFormat(localeDictionary[locale], {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol', // 使用 narrowSymbol 来获取最短的货币符号
  });

  let output = '';

  formatter.formatToParts(0).forEach(({ type, value }) => {
    if (type === 'currency') {
      output = value;
    }
  });

  return output;
};

export default getCurrencySymbol;
